export default "__VITE_ASSET__EOlZTBgh__"